import {createSelector} from 'reselect';

const userState = state => state.user;

export const getUserPayments = createSelector(userState, ({payments}) => payments);
